import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import UiButton1 from './ui_button1';
import UiInput1 from './ui_input1';
import UiSpinner from './ui_spinner';

const BrandEdit = () => {

    const navigate = useNavigate()

    const {
        neonUser,
        editBrandId,
        getBrands,
        hh,
        offCanvas,
        setToastContent,
        toastInit,
        fetchDataV2,
    } = useContext(AppContext)

    const [brand, setBrand] = useState({})
    const [accountTypeList, setAccountTypeList] = useState([])
    const [errorList, setErrorList] = useState([])
    const [generalMessage, setGeneralMessage] = useState("")
    const [loading, setLoading] = useState(false)

    const getAccountType = async () => {
        setAccountTypeList([])
        let query1 = "GET_ACCOUNT_TYPE", params1 = []
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        setAccountTypeList(resp.map(x => x.unnest))
    }

    const getBrand = async () => {
        let query1 = "GET_BRAND_EDIT", params1 = [neonUser.agency_id, editBrandId];

        if (neonUser.role == "admin") {
            query1 = "GET_BRAND_EDIT_ADMIN";
            params1 = [editBrandId];
        }

        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        if (resp.length == 0) navigate("/brand")
        setBrand(resp[0])
    }

    const brandChangeHandler = (value, field) => {
        setBrand({
            ...brand,
            [field]: value
        })
    }

    const updateBrand = async () => {
        setLoading(true)
        setErrorList([])
        setGeneralMessage("")

        let valid = true;
        let err = [];

        (['brand', 'active?', 'account_type']).forEach(x => {
            if ([undefined, null, ""].includes(brand[x])) {
                err.push(x)
                valid = false
            }
        })

        if (!valid) {
            setErrorList(err)
            setLoading(false)
            setGeneralMessage("all required fields must not be empty.")
            return
        }

        let query1 = "UPDATE_BRAND", params1 = [
            brand.brand,
            brand["active?"],
            brand.account_type,
            brand.vendor_revenue_type,
            editBrandId
        ];

        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

        if (!resp) {
            setGeneralMessage("error! please try again.")
            setLoading(false)
            return;
        }

        setGeneralMessage("Brand info successfully updated.")
        getBrands()
        setLoading(false)
        offCanvas.hide()
        setToastContent("Brand info successfully updated.")
        toastInit.show()
        return
    }

    useEffect(() => {
        if (neonUser.user_id && editBrandId && accountTypeList.length > 0) getBrand()
    }, [neonUser, editBrandId, accountTypeList])

    useEffect(() => {
        getAccountType()
    }, [])


    if (!brand.id || accountTypeList.length == 0) return (
        <div className="d-flex justify-content-center" style={{ height: hh / 2 }}>
            <UiSpinner />
        </div>
    )

    return (
        <div className="d-flex flex-column justify-content-between h-100">
            <div className="d-flex flex-column gap-4">
                <div className="d-flex flex-column gap-2">
                    {generalMessage && <p className={errorList.length > 0 ? "poppins text-danger" : "poppins text-success"}>{generalMessage}</p>}
                    <p className="mb-0 fw-bold poppins">Account/Brand Name</p>
                    <UiInput1 value={brand.brand || ""} field={"brand"} userChangeHandler={brandChangeHandler} />
                </div>

                <div className="d-flex flex-column gap-2">
                    <p className="mb-0 fw-bold poppins">Account Type</p>
                    <div className="d-flex gap-3">
                        {accountTypeList.map(x => (
                            <div key={x} className="d-flex gap-3">
                                <input
                                    checked={brand.account_type == x || false}
                                    type="radio" name="account_type" className="input-radio align-self-center"
                                    onChange={e => brandChangeHandler(x, 'account_type')} />
                                <span className="poppins align-self-center text-capitalize">{x == 'ads' ? "Ads Only" : x}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="d-flex flex-column gap-2">
                    <p className="mb-0 fw-bold poppins">Account/Brand Status</p>
                    <div className="d-flex gap-3">
                        <input
                            checked={brand['active?'] || false}
                            type="radio" name="status" className="input-radio align-self-center"
                            onChange={e => brandChangeHandler(true, 'active?')} />
                        <span className="poppins align-self-center">Active</span>

                        <input
                            checked={!brand['active?'] || false}
                            type="radio" name="status" className="input-radio align-self-center"
                            onChange={e => brandChangeHandler(false, 'active?')} />
                        <span className="poppins align-self-center">Inactive</span>
                    </div>
                </div>
            </div>

            {loading ?
                <UiSpinner />
                :
                <UiButton1 text="Save" submit={updateBrand} />
            }
        </div>
    )
}

export default BrandEdit